export default __webpack_public_path__ + "static/media/sports.3a6e9070.PNG";